import { Helmet } from 'react-helmet-async';
import { Center, Separator, Text, Heading } from '@chakra-ui/react';
import ContainerBox from 'src/components/container-box/ContainerBox';
import TopBar from 'src/components/top-bar/TopBar';
import colors from 'src/theme/colors';
import Page from 'src/components/page/Page';
import PersonaliseForm from './PersonaliseForm';

export default function Personalise() {
  return (
    <Page title="Personalise Your Experience">
      <Helmet>
        <style>{`body { 
          background-color: ${colors.podcastShade100};
        }
        @media screen and (max-width: 575px) {
          body {
            background-color: ${colors.white};
          }
        }
   `}</style>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <TopBar />
      <Center minWidth="320px">
        <ContainerBox
          w={{ sm: '100%', md: '510px', lg: '630px', '2xl': '670px' }}
          minWidth="320px"
          my={{ sm: 0, md: '30px', xl: '54px', '2xl': '58px' }}
        >
          <Heading size="h2">We are almost there!</Heading>
          <Text mt="10px" visual="lighter">
            Got a sec to help us tailor Alitu, just for you?
          </Text>
          <Separator mt="30px" borderBottomWidth="2px" />
          <PersonaliseForm />
        </ContainerBox>
      </Center>
    </Page>
  );
}
